"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Button = _interopRequireDefault(require("../../Button/Button"));
var _constants = require("../../constants");
var _MediaContext = require("../../MediaContext/MediaContext");
var _OptionsModal = _interopRequireDefault(require("../components/OptionsModal"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Basic = function Basic(_ref) {
  var centerOptions = _ref.centerOptions,
    filterOptions = _ref.filterOptions,
    hasOptionsModal = _ref.hasOptionsModal,
    activeFilter = _ref.activeFilter,
    updateActiveFilter = _ref.updateActiveFilter,
    children = _ref.children,
    buttonType = _ref.buttonType,
    noBackground = _ref.noBackground;
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('tabs--options', 'basic', 'd8-u-relative', centerOptions && 'text-center'),
    style: {
      zIndex: 'var(--zindex-header)'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "tabs--options__wrapper ".concat(noBackground && 'no-background')
  }, !!filterOptions && filterOptions.length > 0 && /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_MediaContext.Media, {
    lessThan: _constants.BREAKPOINTS.MD
  }, filterOptions.length > 2 ? /*#__PURE__*/_react["default"].createElement(_OptionsModal["default"], {
    filterOptions: filterOptions,
    activeFilter: activeFilter,
    buttonType: buttonType,
    updateActiveFilter: updateActiveFilter
  }) : filterOptions.map(function (option, i) {
    return /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      key: option.text + 1,
      text: option.text,
      buttonType: buttonType || _constants.BUTTON_TYPES.FILTER,
      onClick: function onClick() {
        return updateActiveFilter && updateActiveFilter(i);
      },
      active: activeFilter === i
    });
  })), /*#__PURE__*/_react["default"].createElement(_MediaContext.Media, {
    greaterThanOrEqual: _constants.BREAKPOINTS.MD
  }, !hasOptionsModal ? filterOptions.map(function (option, i) {
    return /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      key: option.text + 1,
      text: option.text,
      buttonType: buttonType || _constants.BUTTON_TYPES.FILTER,
      onClick: function onClick() {
        return updateActiveFilter && updateActiveFilter(i);
      },
      active: activeFilter === i
    });
  }) : /*#__PURE__*/_react["default"].createElement(_OptionsModal["default"], {
    filterOptions: filterOptions,
    activeFilter: activeFilter,
    buttonType: buttonType,
    updateActiveFilter: updateActiveFilter
  }))))), children && /*#__PURE__*/_react["default"].createElement("div", {
    className: "tabs--content"
  }, children({
    activeFilter: activeFilter
  })));
};
Basic.propTypes = {
  children: _propTypes["default"].any.isRequired,
  filterOptions: _propTypes["default"].array.isRequired,
  centerOptions: _propTypes["default"].bool,
  hasOptionsModal: _propTypes["default"].bool,
  noBackground: _propTypes["default"].bool,
  buttonType: _propTypes["default"].string,
  activeFilter: _propTypes["default"].number,
  updateActiveFilter: _propTypes["default"].func
};
var _default = exports["default"] = Basic;